module.exports = __webpack_public_path__ + "static/media/map-marker-slash.76662803.svg";